import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { TemplateLibraryCommandContribution } from './template-library-command-contribution';
import { createTemplateLibraryDialog } from './template-library-dialog-service';
import { TemplateLibraryDialogService } from './template-library-dialog-service.interface';
import { TemplateEditCommandContribution } from './template-edit-command-contribution';
import { createTemplateEditDialog } from './template-edit-dialog-service';
import { TemplateEditDialogService } from './template-edit-dialog-service.interface';
export function templateLibraryModule(bind) {
    bind(CommandContribution).to(TemplateLibraryCommandContribution);
    bind(CommandContribution).to(TemplateEditCommandContribution);
    bind(TemplateLibraryDialogService).toDynamicValue(createTemplateLibraryDialog());
    bind(TemplateEditDialogService).toDynamicValue(createTemplateEditDialog());
}
